var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.classes,style:(_vm.styles),attrs:{"href":"/subscribe/checkout"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }